@if (callouts.length > 0) {
  <div class="container">
    <div class="card flat">
      <div class="flex">
        <div class="text">
          You have new subscribers available from the {{ siteAdvertName }}!
        </div>
        <div class="download">
          <a [href]="currentCallout.url" (click)="clearNotification(currentCallout._id)" target="_blank">Download Your List</a>
        </div>
        <div (click)="clearNotification(currentCallout._id)" class="close">X</div>
      </div>
    </div>
    @if (callouts.length > 1) {
      <div class="card flat fake-1"></div>
    }
    @if (callouts.length > 2) {
      <div class="card flat fake-2"></div>
    }
  </div>
}
